/**
 * Created by Ivan on 24.05.2025
 */

const DoubleTutorial = function () {
    return new TutorialScenario(DoubleTutorial.NAME, {
        listSteps: () => [
            TileGameTutorialHelper.createPlayCardStep(DoubleTutorial.CONFIG)
        ],

        onStart: function () {
            Game.currentGame.shownTutorials.push(DoubleTutorial.NAME);
            Game.currentGame.hand.setCards(DoubleTutorial.CONFIG.handValues);
        },

        isAvailable: () => TileGameTutorialHelper.isAvailable(DoubleTutorial.NAME)
    });
};

DoubleTutorial.NAME = "double";
DoubleTutorial.CONFIG = {
    handValues: ["a"],
    force: "DoubleTutorialMessage"
};
